module.exports = __webpack_public_path__ + "img/66.30904ebe.png";